import "./header.css";
import { Link } from "react-router-dom";

export default function Header({ aboutData }) {
  return (
    // <div className="header">
    //   <div className="headerTitles">
    //     <h2 className="headerTitleSm">{aboutData.subtitle || "BLOG"}</h2>
    //     <h1 className="headerTitleLg">{aboutData.title}</h1>
    //     <button className="headerButton">See the Journey</button>
    //   </div>

    //   <img
    //     className="headerImg"
    //     src={`${process.env.REACT_APP_UPLOAD_URL}${aboutData.main_photo?.url}`}
    //     alt=""
    //   />
    // </div>
    <div
      className="d-flex align-items-center justify-content-start bg-cover bg-center text-white position-relative shadow-elevation-lightbg-high"
      style={{
        backgroundImage: `url(${process.env.REACT_APP_UPLOAD_URL}${aboutData.main_photo?.url})`,
        height: "60vh", // or whatever height you want
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="d-flex flex-column z-3 position-relative ps-lg-5 px-3">
        <h1>{aboutData.title}</h1>
        <h2>{aboutData.subtitle || "BLOG"}</h2>
        <div>
          <Link to="/articles">
            <button className="mt-3 px-3">See the Journey</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
